module.exports = __webpack_public_path__ + "img/2023-fusion-profs-anais-alexi.9f931aa.jpg";